import * as React from 'react';
import Button from '@mui/material/Button';
import Snackbar, { SnackbarCloseReason } from '@mui/material/Snackbar';
import { SnackbarContent } from '@mui/material';


interface customSnackbarProps {
    data: any,
    onClose: () => void;
}

export default function CustomSnackbar(props: customSnackbarProps) {
    const [state, setState] = React.useState<any>({
        vertical: 'top',
        horizontal: 'right',
    });
    const { vertical, horizontal } = state;

    return (
        <div>
            <Snackbar
                anchorOrigin={{ vertical, horizontal }}
                open={props.data.open}
                autoHideDuration={5000}
                onClose={props.onClose}
                message={props.data.message}
            >
                <SnackbarContent
                    message={props.data.message}
                    sx={{
                        backgroundColor: props.data.backgroundColor, // Customize the background color here
                        color: 'white', // Optional: customize text color
                    }}
                />
            </Snackbar>
        </div>
    );
}
